import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const s = r((a, e) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: e,
    ...a,
    image: (t) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...t,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M16 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m4 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0m10 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0M19 27a3 3 0 1 1-6 0 3 3 0 0 1 6 0M5 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6M28 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0M6 28a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
s.displayName = "FightBreakoutsIcon";
export {
  s as FightBreakoutsIcon,
  s as default
};
//# sourceMappingURL=index.js.map
